// controllers
import { getSize } from "controllers/Size";
import { withBaseButtonSelect } from "shared/HOC";
import { sortArrayPipe } from "shared/pipes";


// const country = localStorage.getItem('country');


async function dataStream(callback) {
    const brands = await getSize();
  callback(sortArrayPipe.transform(brands, 'value'));
}
  
const SizeSelect = withBaseButtonSelect([],dataStream, undefined, true);
export default SizeSelect;
